import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import * as queries from '../../queries.js';
import Pagination from '../../utils/Pagination.js';
import DataTable from '../../utils/DataTable.js';
import SearchBarGraph from '../../utils/SearchBarGraph.js';
import { formatLocalTime } from '../../utils/TimeUtils.js'
// import { IoMdReturnLeft } from 'react-icons/io';


function CustomerCreaditLog({ id = 0 }) {
    // const { id } = useParams();
    // const navigate = useNavigate();
    const { t } = useTranslation();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [orderBy, setOrderBy] = useState('-OperDatetime');
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({});
    const [selectedOptions, setSelectedOptions] = useState('');

    const { error, data, loading, refetch } = useQuery(queries.GET_ALL_CREDIT_LOG, {
        variables: {
            orderBy,
            page,
            pageSize,
            search,
            filters: {
                ...filters,
                CustomerID: parseInt(id),
            },
        },
    });

    useEffect(() => {
        refetch();
    }, [filters, page, pageSize, orderBy]);

    if (error) return <p>{t('Error:')} {error.message}</p>;

    const customers = data?.allCreditLog?.data || [];
    const totalPageNum = data?.allCreditLog?.totalPageNum || 1;
    const totalCount = data?.allCreditLog?.totalCount || 0;

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    const handleHeaderClick = (field) => {
        if (!field) {
            return;
        }
        let sortField = field;
        if (orderBy.includes(field)) {
            // If already sorted by this field, toggle between asc and desc
            sortField = orderBy.startsWith('-') ? field : '-' + field;
        }
        setOrderBy(sortField);
    };

    const handleSearch = (filter, searchTerm) => {
        if (filter) {
            setFilters(filter);
        } else {
            setFilters({});
        }

        setSearch(searchTerm);
        setPage(1);
    };

    const handleReset = () => {
        setSearch('');
        setFilters({});
        setSelectedOptions('');
    };

    const handleSearchByChange = (newSearchBy, oldSearchBy) => {
        setSelectedOptions(newSearchBy);
        if (newSearchBy === '') {
            setFilters((prevFilters) => {
                const { [`${oldSearchBy}Ilike`]: _, ...rest } = prevFilters;
                return rest;
            });
            return;
        }
        const newFilters = { ...filters, [`${newSearchBy}Ilike`]: search };
        delete newFilters[`${oldSearchBy}Ilike`];
        setFilters(newFilters)
    };

    const headers = [
        { label: 'Alter', field: 'ModifiedAmount' },
        { label: 'Final', field: 'FinalAmount' },
        { label: 'Time', field: 'OperDatetime' },
        { label: 'Reason', field: 'Reason' },
        { label: 'InvoiceID', field: 'InvoiceID' },
    ];

    const renderRow = (creditLog, index) => (
        <>
            <td>{creditLog.ModifiedAmount}</td>
            <td>{creditLog.FinalAmount}</td>
            <td>{formatLocalTime(creditLog.OperDatetime)}</td>
            <td>{creditLog.Reason}</td>
            <td onClick={() => {
                const parts = creditLog.InvoiceID.split('-');
                const secondLast = parts[parts.length - 2];
                const last = parts[parts.length - 1];
                window.open(`/invoice-details-frontdesk/${secondLast}/${last}`, '_blank');
            }}>
                <u>{creditLog.InvoiceID}</u>
            </td>
        </>
    );

    const searchOptions = [
        { value: '', label: 'All' },
        { value: 'InvoiceID', label: 'InvoiceID' },
        { value: 'Reason', label: 'Reason' },
        { value: 'OperDatetime', label: 'Datetime' },
        { value: 'ModifiedAmount', label: 'Modified Amount' },
        { value: 'FinalAmount', label: 'Final Amount' },
    ];

    return (
        <div className='main-container'>
            {/* <button className="return-button" onClick={() => navigate(`${origin}`)}>
                <IoMdReturnLeft />
            </button> */}
            <div>
                <SearchBarGraph
                    onSearch={handleSearch}
                    onReset={handleReset}
                    searchTerm={search}
                    searchOptions={searchOptions}
                    selectedOptions={selectedOptions}
                    onSearchByChange={handleSearchByChange}
                />
                <div className='table-container'>
                    <DataTable
                        headers={headers}
                        data={customers}
                        onHeaderClick={handleHeaderClick}
                        containerClassName={'table-outer-pagination'}
                        renderRow={renderRow}
                        orderBy={orderBy}
                        loading={loading}
                    />
                </div>
                <Pagination
                    page={page}
                    pageSize={pageSize}
                    totalPageNum={totalPageNum}
                    containerClassName={'pagination-container-sticky'}
                    totalCount={totalCount}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                />
            </div>
        </div>
    );
}

export default CustomerCreaditLog;